import axios from 'axios'
import { apiBaseUrl } from '@/variables/localVariables'


export class APICategory {

  getCategories(filteringType) {
    let url = `${apiBaseUrl}/categories/`
    if (filteringType) {
      url += `?filtering_type=${filteringType}`
    }
    var headers = {
      'Content-Type': 'application/json',
    }
    return axios.get(url, {'headers': headers,})
  }
}
